import Dashboard from "./Dashboard/Dashboard";
import Home from "./Home/Home";
import Support from "./Support/Support";
import CreateTicket from "./Support/CreateTicket";
import TicketView from "./Support/TicketView";
import UserProfile from "./UserProfile/UserProfile";
import ViewUserProfile from "./UserProfile/ViewUserProfile";
import ManageCompanySettings from "./ManageCompanySettings/ManageCompanySettings";
import ChangePassword from "./ChangePassword/ChangePassword";
import VflDashboard from "./VflDashboard/VflDashboard.jsx";
import IncidentManagementDashboard from "./Dashboard/IncidentManagementDasboard/IncidentManagementDashboard";
import TMDashboard from "./Dashboard/TMDashboard/TMDashboard";
import MedicalDashboard from "./Dashboard/MedicalDashboard/MedicalDashboard";
import CapaDashboard from "./Dashboard/CapaDashboard/CapaDashboard";
import OHSCDashboard from "./Dashboard/OHSCDashboard/OHSCDashboard";
import ViewTabFiles from "./_globalConfiguration/HelpManual/ViewTabFiles";
import ReleaseNotes from "./_globalConfiguration/ReleaseNotes/ReleaseNotes";
const AppRoutes = [
  {
    path: "/dashboard",
    component: Dashboard,
    nav: 1,
  },
  {
    path: "/vfl/dashboard",
    component: VflDashboard,
    nav: 1,
  },
  {
    path: "/incident/dashboard",
    component: IncidentManagementDashboard,
    nav: 1,
  },
  {
    path: "/training/dashboard",
    component: TMDashboard,
    nav: 1,
  },
  {
    path: "/ohsc/dashboard",
    component: OHSCDashboard,
    nav: 1,
  },
  {
    path: "/medical/dashboard",
    component: MedicalDashboard,
    nav: 1,
  },
  {
    path: "/capa/dashboard",
    component: CapaDashboard,
    nav: 1,
  },
  // {
  //   path: "/home",
  //   component: Home,
  //   nav: 1,
  // },
  {
    path: "/support/create-ticket",
    component: CreateTicket,
    nav: 1,
  },
  {
    path: "/support/edit-ticket/:sId",
    component: CreateTicket,
    nav: 1,
  },
  {
    path: "/support/ticket-view/:sId",
    component: TicketView,
    nav: 1,
  },
  {
    path: "/support",
    component: Support,
    nav: 1,
  },
  {
    path: "/profile/view",
    component: ViewUserProfile,
    nav: 1,
  },
  {
    path: "/profile",
    component: UserProfile,
    nav: 1,
  },
  {
    path: "/manage-company-setting",
    component: ManageCompanySettings,
    nav: 1,
  },
  {
    path: "/change-password",
    component: ChangePassword,
    nav: 1,
  },
  {
    path: "/help-manual/files",
    component: ViewTabFiles,
    nav: 1,
  },
  {
    path: "/release-notes",
    component: ReleaseNotes,
    nav: 1,
  },
];

export default AppRoutes;
